const logo = '$applicationConfig.Logo'
const minLogo = '$applicationConfig.MinLogo'
export default {
  // В случае если мы запустили приложение с мобилки или планшета, не раскрывать боковое меню
  beforeMount() {
    if (this.needShowBurgerMenu) {
      this.drawer = false
    }
  },

  computed: {
    logoUrl() {
      let logoUrl = this.getExternalSourceField(logo)
      // Если getExternalSourceField не нашел значение по ссылке, тогда логотип по умолчанию
      if (logoUrl === logo) {
        return require('@/assets/it-logo.svg')
      }
      return logoUrl
    },
    minLogoUrl() {
      let logoUrl = this.getExternalSourceField(minLogo)
      // Если getExternalSourceField не нашел значение по ссылке, тогда MinLogo по умолчанию
      if (logoUrl === minLogo) {
        return require('@/assets/logo.svg')
      }
      return logoUrl
    }
  }
}
